import React from 'react';
import './Leaderboard.css';
import { Trash2 } from 'lucide-react';
import Button from './Button';

function LeaderboardTable({
  rows = [],
  showActions = false,
  onBankClick,
  onDeleteClick,
  onEditClick,
  onNameClick,
}) {
  return (
    <div className='leaderboard-container'>
      <table className='leaderboard-table'>
        <thead>
          <tr>
            <th>Rank</th>
            <th>Player</th>
            <th>Points</th>
            <th>Level</th>
            {showActions && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} className={`leaderboard-row rank-${row.rank}`}>
              <td className='rank-cell'>
                {row.rank === 1 && <span className='medal'>🥇</span>}
                {row.rank === 2 && <span className='medal'>🥈</span>}
                {row.rank === 3 && <span className='medal'>🥉</span>}
                {row.rank > 3 && <span className='no-medal'>#{row.rank}</span>}
              </td>
              <td className='player-cell'>
                <div className='player-info'>
                  <span className='player-avatar'>{row.avatar || '🐶'}</span>
                  <span
                    className='player-name'
                    onClick={() => onNameClick && onNameClick(row)}
                    title='View Public Profile'
                    aria-label='View Public Profile'
                  >
                    {row.name}
                  </span>
                </div>
              </td>
              <td className='points-cell'>{row.points ?? 0}</td>
              <td className='level-cell'>{row.levelNumber ?? 0}</td>
              {showActions && (
                <td className='actions-cell'>
                  <Button
                    type='secondary'
                    size='small'
                    style={{ marginRight: 12 }}
                    onClick={() => onBankClick && onBankClick(row)}
                  >
                    Bank
                  </Button>

                  <Button
                    type='tertiary'
                    size='small'
                    style={{ marginRight: 12 }}
                    onClick={() => onEditClick && onEditClick(row)}
                    aria-label='Edit Player'
                    title='Edit Player'
                  >
                    Edit
                  </Button>

                  <Button
                    type='danger'
                    size='small'
                    onClick={() => onDeleteClick && onDeleteClick(row)}
                    aria-label='Delete Player'
                    title='Delete Player'
                  >
                    Delete
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LeaderboardTable;
